/*@ngInject*/
const UIDropZoneDirective = function (coreConstant) {

    let linkFunction = function ($scope, element, attrs) {
        function processDragOverOrEnter(event) {
            if (event) {
                event.preventDefault();
                if (event.type === 'dragover') {
                    element.addClass('dragHover');
                } else if (event.type === 'dragleave') {
                    element.removeClass('dragHover');
                }

            }
            event.originalEvent.dataTransfer.effectAllowed = 'copyMove';
            return false;
        }

        function handleDrop(event) {
            let file,
                reader;
            if (event) {
                event.preventDefault();
            }

            element.removeClass('dragHover');

            reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$emit(coreConstant.event.FILE_DROPPED, file);
            };
            file = event.originalEvent.dataTransfer.files[0];
            reader.readAsDataURL(file);
            return false;
        }

        element.on('dragover', processDragOverOrEnter);
        element.on('dragenter', processDragOverOrEnter);
        element.on('dragleave', processDragOverOrEnter);
        element.on('drop', handleDrop);

        $scope.$on('$destroy', function () {
            element.off('dragover', processDragOverOrEnter);
            element.off('dragenter', processDragOverOrEnter);
            element.off('dragleave', processDragOverOrEnter);
            element.off('drop', handleDrop);
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiDropZone', UIDropZoneDirective);
